import EFOcats_answer from './efocats_answer.js';
import EFOcats_import_html from '../import/efocats_import_html.js';

/**
 * tmp[0] === "set-calendar"の時の回答欄設置処理
 */
export default class EFOcats_answer_calendar extends EFOcats_answer {
  /**
   * 回答欄設置
   */
  set(tmp, answer, elem) {
    const input = elem.find('.dateSetting').append(EFOcats_import_html.getValue('common-question', {name: answer.name}));
    this.attr(input.find('input').last().get(0), answer, elem);
  }
}
